"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrama = void 0;
//@ts-nocheck
const react_1 = require("react");
const switch_1 = require("@orama/switch");
const useBaseUrl_1 = __importDefault(require("@docusaurus/useBaseUrl"));
const useIsBrowser_1 = __importDefault(require("@docusaurus/useIsBrowser"));
const theme_common_1 = require("@docusaurus/theme-common");
const useGlobalData_1 = require("@docusaurus/useGlobalData");
const pako_1 = require("pako");
const client_1 = require("@oramacloud/client");
const orama_1 = require("@orama/orama");
const plugin_analytics_1 = require("@orama/plugin-analytics");
const utils_1 = require("../../utils");
const useOrama = () => {
    const [searchBoxConfig, setSearchBoxConfig] = (0, react_1.useState)({
        basic: null,
        custom: null
    });
    const { colorMode } = (0, theme_common_1.useColorMode)();
    const { searchData, endpoint, analytics, searchBoxCustomConfig, searchBtnConfig } = (0, useGlobalData_1.usePluginData)('@orama/plugin-docusaurus-v3');
    const baseURL = (0, useBaseUrl_1.default)('orama-search-index-current.json.gz');
    const isBrowser = (0, useIsBrowser_1.default)();
    (0, react_1.useEffect)(() => {
        async function loadOrama() {
            let oramaInstance = null;
            if (endpoint === null || endpoint === void 0 ? void 0 : endpoint.url) {
                oramaInstance = new client_1.OramaClient({
                    endpoint: endpoint.url,
                    api_key: endpoint.key
                });
            }
            else {
                let buffer;
                if (searchData === null || searchData === void 0 ? void 0 : searchData.current) {
                    buffer = searchData.current.data;
                }
                else {
                    const searchResponse = await fetch(baseURL);
                    if (searchResponse.status === 0) {
                        throw new Error(`Network error: ${await searchResponse.text()}`);
                    }
                    else if (searchResponse.status !== 200) {
                        throw new Error(`HTTP error ${searchResponse.status}: ${await searchResponse.text()}`);
                    }
                    buffer = await searchResponse.arrayBuffer();
                }
                const deflated = (0, pako_1.ungzip)(buffer, { to: 'string' });
                const parsedDeflated = JSON.parse(deflated);
                const db = await (0, orama_1.create)({
                    schema: { ...utils_1.DOCS_PRESET_SCHEMA, version: 'enum' },
                    plugins: [
                        ...(analytics
                            ? [
                                (0, plugin_analytics_1.pluginAnalytics)({
                                    apiKey: analytics.apiKey,
                                    indexId: analytics.indexId,
                                    enabled: analytics.enabled
                                })
                            ]
                            : [])
                    ]
                });
                await (0, orama_1.insertMultiple)(db, Object.values(parsedDeflated.docs.docs));
                oramaInstance = new switch_1.Switch(db);
            }
            setSearchBoxConfig({
                basic: {
                    clientInstance: oramaInstance,
                    facetProperty: 'category',
                },
                custom: searchBoxCustomConfig
            });
        }
        if (!isBrowser) {
            return;
        }
        loadOrama().catch((error) => {
            console.error('Cannot load search index.', error);
        });
    }, [isBrowser]);
    return { searchBoxConfig, searchBtnConfig, colorMode, clientMode: (endpoint === null || endpoint === void 0 ? void 0 : endpoint.url) ? 'cloud' : 'oss' };
};
exports.useOrama = useOrama;
